import React, { Component } from 'react'
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context"
import Icon from "../common/icon/icon.component.jsx"
import PaymentTermSelect from '../payment-term/locationselect.component.jsx'
const uuidv4 = require('uuid/v4')

class InvoicePaymentTerm extends Component {
    constructor(props, context) {
        super(props, context)

        this.state = {
            paymentTerm: this.props.value,
            paymentTermId: this.props.paymentTermId,
            invoiceId: this.props.invoiceId || null,
            uniqueId: uuidv4(),
            editable: this.props.editable || false,
            editMode: false,
            hover: false,
            onChange: this.props.onChange || function() {}
        }
        this.loadPaymentTerm = this.loadPaymentTerm.bind(this)
        this.triggerEdit = this.triggerEdit.bind(this)
        this.onSave = this.props.onSave || function() {}
        this.save = this.save.bind(this)
        this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this)
        this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            paymentTerm: nextProps.value,
            paymentTermId: nextProps.paymentTermId,
            invoiceId: nextProps.invoiceId || null
        })
    }

    componentDidMount() {}

    onMouseEnterHandler() {
        this.setState({
            hover: true
        })
    }

    onMouseLeaveHandler() {
        this.setState({
            hover: false
        })
    }

    triggerEdit(event) {
        event?.preventDefault()
        this.setState({
            editMode: !this.state.editMode
        })
    }

    loadPaymentTerm(paymentTermId) {
        this.setState({
            paymentTermId: paymentTermId
        })
    }

    save(event) {
        event.preventDefault()
        AppContext.getApiClient()
            .patch("/invoices/" + this.state.invoiceId, {
                paymentTermId: this.state.paymentTermId
            })
            .then(r => {
                this.setState(
                    {
                        paymentTerm: r.attributes.paymentTerm ? r.attributes.paymentTerm.attributes.name : "",
                        dueDate: r.attributes.dueDate,
                        editMode: false
                    },
                    () => {
                        this.state.onChange(this.state.paymentTerm, this.state.dueDate)
                    }
                )
            })
    }

    render() {
        let term = this.state.paymentTerm
        if (this.state.editable) {
            let link = (
                <a
                    href={"#"}
                    onClick={this.triggerEdit}
                    onMouseEnter={this.onMouseEnterHandler}
                    onMouseLeave={this.onMouseLeaveHandler}
                >
                    {term} <Icon value={"pencil-alt"} className={"ml-1 " + (!this.state.hover ? "text-gray" : "")} />
                </a>
            )
            term = (
                <span>
                    {link}
                    <div className={"dropdown-menu p-4 " + (this.state.editMode ? "show" : "")} style={{ minWidth: "350px" }}>
                        <div className="w-100 m-0">
                            <PaymentTermSelect
                                value={this.state.paymentTermId}
                                onChange={this.loadPaymentTerm}
                                className="form-control"
                            />
                        </div>
                        <p className="m-0 pt-2">
                            <button className="btn btn-sm btn-outline-secondary" onClick={this.triggerEdit}>
                                <Icon value={"arrow-left"} />
                            </button>
                            <button className="btn btn-sm btn-outline-primary ml-2" onClick={this.save}>
                                <Icon value={"save"} />
                            </button>
                        </p>
                    </div>
                </span>
            )
        }

        return term
    }
}

export default InvoicePaymentTerm



// WEBPACK FOOTER //
// ./src/invoice/paymentterm.component.jsx